module.exports = __webpack_public_path__ + "static/media/gridShieldPykes.50174e19.jpg";